import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { siteConfig } from '@config/site';
export const usePageTitle = (titleKey) => {
    const { t, i18n } = useTranslation();
    useEffect(() => {
        document.title = titleKey ? `${t(titleKey)} | ${siteConfig.name}` : siteConfig.name;
    }, [i18n.language, t, titleKey]);
};
